<template>
  <div
    :id="this.row.fields ? this.row.fields.row_id : ''"
    :class="wrapClasses"
    :lazy-background="backgroundImage"
    class="row--container"
  >
    <div :class="container">
      <div
        v-if="row?.fields?.content?.length > 0"
        ref="contentWrap"
        :class="rowClasses"
      >
        <template v-for="(entry, index) in row.fields.content">
          <Column
            v-if="entry?.sys?.contentType?.sys?.id === 'modularColumn'"
            :column="entry"
            :length="row.fields.content.length"
            :key="index + 'column'"
          />
          <DevModulesWrapper
            v-else-if="entry?.sys?.contentType?.sys?.id === 'devModule'"
            :modules="entry?.fields"
            :key="index + 'devmodule'"
          />
          <CarouselWrapper
            v-else-if="entry?.sys?.contentType?.sys?.id === 'carousel'"
            :carousel="entry.fields"
            :key="index + 'carousel'"
          />
        </template>
      </div>
    </div>
    <div v-if="isVideo" class="hero--video">
      <Video :video="this?.row?.fields?.backgroundImage?.fields" />
    </div>
  </div>
</template>
<style lang="scss">
.row--container {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  a {
    font-family: "Roboto", Helvetica, sans-serif;
    color: #00263e;
    text-transform: none;

    strong {
      font-weight: 600;
    }
  }

  h3 {
    font-size: 32px;
    line-height: 38px;
    letter-spacing: -0.25px;
  }

  @media (max-width: 736px) {
    h3 {
      font-size: 28px;
      line-height: 32px;
      letter-spacing: -0.25px;
    }
  }

  h5 {
    font-size: 24px;
    line-height: 33px;
    font-weight: 400;
  }

  p {
    font-size: 16px;
    line-height: 20px;
  }
}

.hero--tall {
  height: 640px;

  @media (max-width: theme("screens.md")) {
    height: 525px;
  }
}

.hero--narrow {
  height: 360px;

  @media (max-width: theme("screens.md")) {
    height: 320px;
  }
}

.hero--video {
  & > div {
    @apply absolute overflow-hidden top-0 left-0 w-full h-full;
  }

  video {
    @apply w-full max-w-none min-h-full relative object-cover;

    top: 50%;
    transform: translate(0, -50%);

    @media (max-width: theme("screens.lg")) {
      width: 120%;
      left: -10%;
    }

    @media (max-width: theme("screens.md")) {
      width: 187%;
      left: -20%;
    }

    @media (max-width: theme("screens.sm")) {
      width: 246%;
      left: -47%;
    }
  }
}

.hero--fade-out {
  @apply text-center flex-wrap;

  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 12%
  );

  .hero--video {
    z-index: -1;
  }
  h1 {
    @screen md {
      font-size: 60px;
      line-height: 70px;
      font-weight: 500;
    }
  }
  @screen md {
    @apply text-left flex-no-wrap;

    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 20%
    );

    .hero--video video {
      width: auto;
      max-height: 100%;
      float: right;
      left: auto;
    }
  }
  @media (max-width: theme("screens.md")) {
    height: auto;

    .hero--video > div {
      @apply relative;
    }

    .hero--video {
      @apply relative;
    }

    .hero--video::before {
      @apply absolute w-full h-full top-0 left-0 z-10;

      content: "";
      background: rgb(255, 255, 255);
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 0) 12%
      );
    }

    .hero--video video {
      width: 160%;
      left: auto;
      top: 0;
      transform: none;
      float: right;
    }

    .flex:first-of-type {
      @apply pb-1;
    }
  }
}

.bg--two-thirds-light-blue {
  background: linear-gradient(
    to right,
    theme("colors.blue.lighter") 66%,
    theme("colors.white") 33%
  );
}
.bg--two-thirds-light-blue-reverse {
  background: linear-gradient(
    to left,
    theme("colors.blue.lighter") 66%,
    theme("colors.white") 33%
  );
}

.bg--half-light-blue {
  background: linear-gradient(
    to bottom,
    theme("colors.blue.lighter") 60%,
    theme("colors.white") 30%
  );
}

.bg--70-dark-blue {
  background: linear-gradient(
    theme("colors.blue.dark") 70%,
    theme("colors.white") 30%
  );
  background-size: 100% 101% !important;
}

.hero--contact {
  padding-bottom: 75px;

  img {
    margin-bottom: 50px;
  }

  @media (min-width: theme("screens.lg")) {
    img {
      top: 160px;
      position: absolute;
    }
  }

  h1 {
    @apply mt-1 mb-2;
  }

  @media (max-width: theme("screens.lg")) {
    background: theme("colors.blue.lighter");
    padding-bottom: 0;

    & .column:last-of-type {
      margin-top: 50px;
    }

    h1 {
      @apply mt-0;
    }
  }

  @media (min-width: theme("screens.md")) and (max-width: theme("screens.lg")) {
    .column {
      @apply w-12/12;

      &:nth-of-type(4) {
        order: -1;
      }

      &:nth-of-type(1) {
        order: -2;
      }
    }

    .btn {
      @apply mb-3;
    }

    .flex {
      @apply pt-2;
    }
  }
}
.hero--contact-reverse {
  padding-bottom: 75px;

  img {
    margin-bottom: 50px;
  }

  h1 {
    @apply mt-1 mb-2;
  }

  @media (max-width: theme("screens.md")) {
    background: linear-gradient(
      to bottom,
      theme("colors.blue.lighter") 66%,
      theme("colors.white") 33%
    );
    padding-bottom: 0;

    & .column:last-of-type {
      margin-top: 50px;
    }

    h1 {
      @apply mt-0;
    }
  }
}
.flex-col-reverse .column:not(:first-of-type) {
  @media (max-width: theme("screens.md")) {
    @apply mb-1;
  }
}
.flex-col-reverse .column:not(:last-of-type) {
  @media (max-width: theme("screens.md")) {
    @apply mb-0;
  }
}
</style>
<script>
import DevModulesWrapper from "./DevModulesWrapper";
import CarouselWrapper from "./CarouselWrapper";
import fadeOut from "../../mixins/fadeOut";
import get from "../../mixins/get.js";
import Column from "./Column";
import Video from "./Video";

export default {
  mixins: [fadeOut, get],

  props: {
    row: {
      type: Object,
      required: true,
    },
  },

  components: { Column, Video, DevModulesWrapper, CarouselWrapper },
  computed: {
    wrapClasses() {
      const bgColors = {
        "Light Gray": "bg-gray-lighter",
        "Light Blue": "bg-blue-lighter",
        "Dark Blue": "bg-blue-dark text--all-white",
        "Vertical 70% Dark Blue": "bg--70-dark-blue text--all-white",
        "Vertical Half Light Blue": "bg--half-light-blue",
        "Horizontal 80% Light Blue": "bg--eighty-percent-light-blue",
        "Dark Gray": "bg-gray-darkest text--all-white",
        White: "bg-white",
        Green: "bg-green",
      };
      const bgImageClasses =
        this.get(this.row, "fields.backgroundImage", false) &&
        this.get(this.row,"fields.backgroundImage.sys.contentType.sys.id", false) === "image" &&
        this.get(this.row,"fields.backgroundImage.fields.image.fields.file.url", false)
          ? " bg-center bg-cover bg-no-repeat"
          : "";

      const bgColor = this?.row?.fields?.backgroundColor
        ? ` ${bgColors[this.row.fields.backgroundColor]}`
        : "";

      const heroTypes = {
        Tall: "hero--tall",
        Narrow: "hero--narrow",
        Contact: "hero--contact bg--two-thirds-light-blue",
        "Contact Reverse":
          "hero--contact-reverse bg--two-thirds-light-blue bg--two-thirds-light-blue-reverse",
        "Fade Out": "hero--fade-out h-460 flex relative items-center",
      };

      const heroType = this.row.fields && this.row.fields.heroType
        ? ` ${heroTypes[this.row.fields.heroType]}`
        : "";

      const bannerClasses = ` h-460 items-center flex text--all-white dim dim--light ${bgImageClasses}`;

      if (this?.row?.fields?.rowStyle === "Body" || this?.row?.fields?.rowStyle === "Modal Popup") {
        return `${bgColor}${bgImageClasses}`;
      } else if (this?.row?.fields?.rowStyle === "Hero Top") {
        if (this?.row?.fields?.heroType === "Contact" || this?.row?.fields?.heroType === "Contact Reverse") {
          return heroType;
        } else if (this?.row?.fields?.heroType === "Fade Out") {
          return `${bgImageClasses} ${heroType}`;
        }
        return `${bannerClasses}${heroType}`;
      } else if (this?.row?.fields?.rowStyle === "Hero Bottom") {
        return ` text-center ${bannerClasses}`;
      } else {
        return "";
      }
    },
    container() {
      if ((this?.row?.fields?.rowStyle === "Body" &&
          this?.row?.fields?.fullWidth == true) ||
        (typeof this?.row?.fields?.content !== "undefined" &&
          this?.row?.fields?.content[0]?.sys?.contentType?.sys?.id !== "modularColumn")
      ) {
        return "";
      } else {
        return "w-full px-gap2 lg:container z-10";
      }
    },
    rowClasses() {
      //Return all template literals with 1 space in the beginning so class output stays clean if an empty string is returned
      const paddingClassDesktop = {
        Default: "4",
        "0px": "0",
        "20px": "1",
        "35px": "2",
        "50px": "3",
        "80px": "4",
        "120px": "5",
        "180px": "6",
      };
      const paddingClassMobile = {
        Default: "3",
        "0px": "0",
        "20px": "1",
        "35px": "2",
        "50px": "3",
        "80px": "4",
        "120px": "5",
        "180px": "6",
      };
      const paddingClasses = {
        paddingDesktopTop: this?.row?.fields?.desktopPaddingTop
          ? ` md:pt-${paddingClassDesktop[this.row.fields.desktopPaddingTop]}`
          : ` md:pt-${paddingClassDesktop["Default"]}`,
        paddingDesktopBottom: this?.row?.fields?.desktopPaddingBottom
          ? ` md:pb-${
              paddingClassDesktop[this?.row?.fields?.desktopPaddingBottom]
            }`
          : ` md:pb-${paddingClassDesktop["Default"]}`,
        paddingMobileTop: this?.row?.fields?.mobilePaddingTop
          ? ` pt-${paddingClassMobile[this.row.fields.mobilePaddingTop]}`
          : ` pt-${paddingClassMobile["Default"]}`,
        paddingMobileBottom: this?.row?.fields?.mobilePaddingBottom
          ? ` pb-${paddingClassMobile[this.row.fields.mobilePaddingBottom]}`
          : ` pb-${paddingClassMobile["Default"]}`,
      };
      //purgecss: pt-0 pt-1 pt-2 pt-3 pt-4 pt-5 pt-6 pb-0 pb-1 pb-2 pb-3 pb-4 pb-5 pb-6 md:pt-0 md:pt-1 md:pt-2 md:pt-3 md:pt-4 md:pt-5 md:pt-6 md:pb-0 md:pb-1 md:pb-2 md:pb-3 md:pb-4 md:pb-5 md:pb-6
      const mobileSwap =
        this.row.fields.swapOrderMobile == true
          ? " flex-col-reverse md:flex-row items-start"
          : "";

      const columnLayoutClasses =
        this?.row?.fields?.content[0]?.sys?.contentType?.sys?.id === "modularColumn"
          ? "flex -mx-gap flex-wrap "
          : "";

      return `${columnLayoutClasses}${mobileSwap}${paddingClasses.paddingDesktopTop}${paddingClasses.paddingDesktopBottom}${paddingClasses.paddingMobileBottom}${paddingClasses.paddingMobileTop}`;
    },
    backgroundImage() {
      return this?.row?.fields?.backgroundImage?.sys?.contentType?.sys?.id === "image" &&
        this?.row?.fields?.backgroundImage?.fields?.image?.fields?.file?.url
        ? this.row.fields.backgroundImage.fields.image.fields.file.url
        : "";
    },
    isVideo() {
      return this?.row?.fields?.backgroundImage?.sys?.contentType?.sys?.id === "video"
        ? true
        : false;
    },
  },
  methods: {
    closeModal() {
      const modalParent = event.target.closest(".modal");

      this.fadeOut(modalParent);
    },
    closeModalBg() {
      if (event.target == event.currentTarget) {
        this.fadeOut(event.currentTarget);
      }
    },
  },
};
</script>
